// MODULES
import React from "react";
import PropTypes from "prop-types";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class QuestionField extends React.PureComponent {
	static propTypes = {
		Component: PropTypes.any.isRequired,
		description: PropTypes.any
	};

	render() {
		const {props} = this;
		const {Component, description} = props;
		const classes = createClassName("Cob-QuestionField", {
			"custom-description": !!description && typeof description !== "string",
		});

		return (
			<div className={classes}>
				<div className="Cob-QuestionField-description">{description}</div>
				<Component {...props} description={undefined}/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/QuestionField/QuestionField.js